import React, { useEffect, useState, useCallback } from "react";
import "../Services/Services.css";
import CharIcon from "../../Assets/img/word.png";
import UploadIcon from "../../Assets/img/upload.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import TestimonialVideoPreview from "./TestimonialVideoPreview";
const TestimonialVideoEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const videoData = location.state?.testimonialvideoedit;

    useEffect(() => {
        if (!videoData) {
            navigate(`/testimonialedit/${id}`);
        }
    }, [videoData]);

    const [languageId, setLanguageId] = useState(videoData?.language_id || 1);
    const [name, setName] = useState(videoData?.name || "");
    const [professional, setProfessional] = useState(videoData?.professional || "");
    const [description, setDescription] = useState(videoData?.description || "");
    const [videoUrl, setVideoUrl] = useState(videoData?.videos || "");
    const [loading, setLoading] = useState(false);
    const [showPreviewTestimonialVideo, setShowPreviewTestimonialVideo] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [allVideos, setAllVideos] = useState([]);

    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });

    const showPopup = (title, message, type = "info") => {
        setPopup({ show: true, title, message, type });
    };

    const getPlainTextLength = useCallback((html = "") => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent?.length || 0;
    }, []);

    const convertToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });

    const handleVideoUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        convertToBase64(file)
            .then((base64) => {
                const payload = {
                    name: file.name,
                    video: [
                        {
                            base64: base64,
                            type: file.type,
                            size: 20000000
                        },
                    ],
                };

                setLoading(true);

                API.post("/videoUpload/add", payload)
                    .then((res) => {
                        setLoading(false);

                        const uploadedUrl = res.data.video_url || res.data.url;

                        if (uploadedUrl) {
                            setVideoUrl(uploadedUrl);
                            showPopup("Success", "Video uploaded successfully!", "success");
                        } else {
                            showPopup("Error", "Video upload failed!", "error");
                        }
                    })
                    .catch(() => {
                        setLoading(false);
                        showPopup("Error", "Upload failed!", "error");
                    });
            })
            .catch(() => {
                showPopup("Error", "Cannot convert file!", "error");
            });
    };

    const handleUpdate = () => {
        if (!name.trim() || !professional.trim() || !description.trim()) {
            return showPopup("Warning", "Please fill all required fields!", "error");
        }

        if (!videoUrl) {
            return showPopup("Warning", "Please upload a video!", "error");
        }

        const payload = {
            videotestimonial_id: id,
            language_id: Number(languageId),
            testimonial_id: videoData?.testimonial_id,
            videos: videoUrl,
            name,
            professional,
            description,
            status: "active",
            active: 1,
        };

        API.post("/videotestimonial_edit/update", payload)
            .then((res) => {
                if (res.data.success) {
                    showPopup("Success", "Video testimonial updated!", "success");
                } else {
                    showPopup("Error", "Update failed!", "error");
                }
            })
            .catch(() => {
                showPopup("Error", "Server error!", "error");
            });
    };
    useEffect(() => {
        if (!videoData?.testimonial_id) return;

        Promise.all([
            API.post("testimoniallistview/condition", {
                language_id: 1,
                home_id: 2,
                testimonial_id: videoData.testimonial_id
            }),
            API.post("testimoniallistview/condition", {
                language_id: 2,
                home_id: 4,
                testimonial_id: videoData.testimonial_id
            })
        ])
            .then(([res1, res2]) => {
                const videos1 = res1.data?.data?.video_testimonials || [];
                const videos2 = res2.data?.data?.video_testimonials || [];

                setAllVideos([...videos1, ...videos2]);
            })
            .catch(err => console.error(err));
    }, [videoData]);



    const handlePreview = () => {
        if (!name.trim()) {
            return showPopup("Required", "Name is required for preview!", "info");
        }

        if (!professional.trim()) {
            return showPopup("Required", "Professional field is required for preview!", "info");
        }

        if (!description.trim()) {
            return showPopup("Required", "Description is required for preview!", "info");
        }

        if (!videoUrl) {
            return showPopup("Required", "Please upload a video before preview!", "info");
        }
        const updatedVideos = allVideos.map((video) =>
            video.videotestimonial_id === videoData.videotestimonial_id
                ? {
                    ...video,
                    videos: videoUrl,
                    name,
                    professional,
                    description,
                }
                : video
        );

        const finalVideos =
            updatedVideos.length > 0
                ? updatedVideos
                : [
                    {
                        videotestimonial_id: videoData.videotestimonial_id,
                        videos: videoUrl,
                        name,
                        professional,
                        description,
                    },
                ];

        setPreviewData({
            videoTestimonials: finalVideos
        });

        setShowPreviewTestimonialVideo(true);
    };


    return (
        <div className="newss-containeradd">
            <div className="service-header-bar">
                <h2 className = "services-title1">Edit Video Testimonial</h2>

                <div className="button-group">
                    <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button>
                    <button className="language-save-btn" onClick={handleUpdate}>
                        Save
                    </button>

                    <button
                        onClick={() => navigate(`/testimonialedit/${id}`)}
                        className="language-cancel-btn"
                    >
                        Back
                    </button>
                </div>
            </div>

            <div className="service-container">

                {/* LEFT SECTION */}
                <div className="left-form">
                    <div className="upload-section">
                        <label>
                            Upload Video<span className="required">*</span>
                        </label>

                        <div className="service-upload-box">
                            {videoUrl ? (
                                <video width="100%" controls>
                                    <source src={videoUrl} type="video/mp4" />
                                </video>
                            ) : (
                                <>
                                    <img src={UploadIcon} alt="Upload" className="upload-icon" />
                                    <p>Click to upload</p>
                                </>
                            )}

                            <input type="file" accept="video/*" onChange={handleVideoUpload} />
                        </div>

                        {loading && <p>Uploading...</p>}
                    </div>
                </div>

                {/* RIGHT SECTION */}
                <div className="testimonial-right-section">
                    <div className="form-group">
                        <label>Name <span className="required">*</span></label>
                        <input
                            type="text"
                            value={name}
                            maxLength={70}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label>Professional <span className="required">*</span></label>
                        <input
                            type="text"
                            value={professional}
                            maxLength={150}
                            onChange={(e) => setProfessional(e.target.value)}
                        />
                    </div>

                    <div className="news-form-group editor-small">
                        <label className="news-description-label">
                            <span>Description <span className="required">*</span></span>

                            <div className="char-wrapper">
                                <img src={CharIcon} alt="chars" />
                                <span className="char-count">{getPlainTextLength(description)}/4000</span>
                            </div>
                        </label>

                        <CKEditor
                            editor={ClassicEditor}
                            data={description}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                if (getPlainTextLength(data) <= 4000) {
                                    setDescription(data);
                                }
                            }}
                            config={{
                                toolbar: ["undo", "redo", "|", "bold", "italic", "underline", "|", "bulletedList", "numberedList"]
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* POPUP */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <button
                            className="btn ok-btn"
                            onClick={() => {
                                setPopup({ ...popup, show: false });

                                if (popup.type === "success") {
                                    navigate(`/testimonialedit/${videoData.testimonial_id}?lang=${languageId}`);
                                }
                            }}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
            {showPreviewTestimonialVideo && (
                <TestimonialVideoPreview
                    previewService={previewData}
                    setShowPreviewTestimonialVideo={setShowPreviewTestimonialVideo}
                />
            )}
        </div>
    );
};

export default TestimonialVideoEdit;
